import * as React from 'react';
type IconInformeEUProps = React.SVGProps<SVGSVGElement>;

export const IconInformeEU: React.FC<IconInformeEUProps> = (props) => (
	<svg
		width={76}
		height={66}
		viewBox="0 0 76 66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<mask
			id="mask0_4527_2392"
			maskUnits="userSpaceOnUse"
			x="0"
			y="13"
			width="54"
			height="53">
			<circle
				cx="27.2322"
				cy="39.2686"
				r="26.2686"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_4527_2392)">
			<circle
				cx="27.2322"
				cy="39.2686"
				r="26.2686"
				fill="#7EAE90"
			/>
			<g clipPath="url(#clip0_4527_2392)">
				<path
					d="M30.6972 49.7761C45.5781 45.2515 49.9609 62.9104 57.8414 40.1443C58.5419 24.7334 46.4584 16.7945 40.3291 14.7513C36.5347 18.2538 27.545 25.4339 21.9411 26.1344C14.9361 27.01 22.8167 38.393 15.8117 41.0199C8.80677 43.6468 14.0605 54.8346 30.6972 49.7761Z"
					fill="#EBF8F0"
				/>
				<path
					d="M25.4436 57.6567C12.8347 52.7532 6.17996 55.0298 3.5531 57.6567C21.0655 72.367 38.8697 66.121 45.5828 61.1591C44.7072 61.451 38.0525 62.5601 25.4436 57.6567Z"
					fill="#EBF8F0"
				/>
			</g>
		</g>
		<circle
			cx="44.3085"
			cy="21.7714"
			r="21.3085"
			fill="#FFA692"
		/>
		<circle
			cx="44.3744"
			cy="21.4156"
			r="17.1203"
			fill="#EBF8F0"
		/>
		<path
			d="M56.3586 37.533L58.7798 35.1118L73.8258 50.1578C74.4944 50.8264 74.4944 51.9104 73.8258 52.579C73.1572 53.2476 72.0732 53.2476 71.4046 52.579L56.3586 37.533Z"
			fill="#FFA692"
		/>
		<path
			d="M36.0644 24.9002C35.5803 24.9002 35.1706 24.7512 34.8355 24.4533C34.519 24.1368 34.3607 23.7458 34.3607 23.2803C34.3607 22.8148 34.519 22.4331 34.8355 22.1352C35.1706 21.8373 35.5803 21.6884 36.0644 21.6884H44.5547C45.0388 21.6884 45.4391 21.8373 45.7556 22.1352C46.0908 22.4331 46.2584 22.8148 46.2584 23.2803C46.2584 23.7458 46.0908 24.1368 45.7556 24.4533C45.4391 24.7512 45.0388 24.9002 44.5547 24.9002H36.0644ZM36.0644 20.655C35.5803 20.655 35.1706 20.5061 34.8355 20.2082C34.519 19.8916 34.3607 19.5006 34.3607 19.0351C34.3607 18.5697 34.519 18.188 34.8355 17.8901C35.1706 17.5922 35.5803 17.4432 36.0644 17.4432H44.5547C45.0388 17.4432 45.4391 17.5922 45.7556 17.8901C46.0908 18.188 46.2584 18.5697 46.2584 19.0351C46.2584 19.5006 46.0908 19.8916 45.7556 20.2082C45.4391 20.5061 45.0388 20.655 44.5547 20.655H36.0644ZM46.2863 31.1283C45.0202 31.1283 43.8192 30.9142 42.6835 30.4859C41.5477 30.0577 40.533 29.4246 39.6392 28.5868C38.7641 27.7489 38.0659 26.7062 37.5446 25.4588C37.0419 24.1927 36.7905 22.731 36.7905 21.0739C36.7905 19.6403 37.0233 18.3183 37.4887 17.1081C37.9542 15.8978 38.6152 14.8551 39.4717 13.98C40.3282 13.0863 41.3336 12.3974 42.488 11.9133C43.6424 11.4106 44.9085 11.1592 46.2863 11.1592C46.9938 11.1592 47.692 11.2523 48.3809 11.4385C49.0885 11.6247 49.7401 11.8947 50.3359 12.2485C50.82 12.4905 51.0993 12.8722 51.1738 13.3935C51.2669 13.9149 51.1366 14.3897 50.7828 14.8179C50.5408 15.1531 50.2242 15.3392 49.8332 15.3765C49.4608 15.4137 49.0792 15.3392 48.6882 15.1531C48.3344 14.9482 47.9527 14.79 47.5431 14.6783C47.1335 14.5665 46.7145 14.5107 46.2863 14.5107C45.076 14.5107 44.0054 14.79 43.0745 15.3486C42.1435 15.9071 41.4174 16.6798 40.896 17.6666C40.3933 18.6348 40.142 19.7706 40.142 21.0739C40.142 22.5821 40.4119 23.8389 40.9519 24.8443C41.5105 25.8311 42.2552 26.5666 43.1862 27.0507C44.1171 27.5348 45.1505 27.7768 46.2863 27.7768C46.7145 27.7768 47.1241 27.7303 47.5151 27.6372C47.9248 27.5441 48.3158 27.3765 48.6882 27.1345C49.0792 26.9483 49.4608 26.8831 49.8332 26.939C50.2242 26.9948 50.5501 27.1903 50.8107 27.5255C51.1831 27.991 51.3135 28.4751 51.2017 28.9778C51.1086 29.4619 50.8294 29.8156 50.3639 30.0391C49.9356 30.2811 49.4981 30.4859 49.0512 30.6535C48.6044 30.8025 48.1482 30.9142 47.6827 30.9886C47.2359 31.0817 46.7704 31.1283 46.2863 31.1283Z"
			fill="#7EAE90"
		/>
		<defs>
			<clipPath id="clip0_4527_2392">
				<rect
					width="49.0346"
					height="52.5371"
					fill="white"
					transform="translate(6.21738 13.0001)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export default IconInformeEU;
